<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div>
          <div class="headline">Duration Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="index" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.duration }}</td>
          <td class="text-xs-left">{{ props.item.durationVal }}</td>
          <td class="text-xs-left">{{ props.item.durationDesc }}</td>
          <td class="text-xs-left">{{ props.item.durationTypeDesc }}</td>
          <td class="text-xs-right">
            <table-action remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New Duration<v-icon>mdi-plus</v-icon></v-btn>
    </v-card>
    <v-dialog v-model="ctyDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ labels.valueFormTitle }}</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <form>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6 v-if="newCty">
                  <v-text-field v-model="durationForm.duration" :label="labels.duration" :error-messages="errors.collect('duration')" data-vv-name="duration" :data-vv-as="labels.duration" v-validate="'required|param|max:4'"></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{labels.duration}}</v-subheader>
                  <div class="subheading">{{durationForm.duration}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="durationForm.durationVal" :label="labels.durationVal" :error-messages="errors.collect('durationVal')" data-vv-name="durationVal" :data-vv-as="labels.durationVal" v-validate="'required|max:10|numeric'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="durationForm.durationDesc" :label="labels.durationDesc" :error-messages="errors.collect('durationDesc')" data-vv-name="durationDesc" :data-vv-as="labels.durationDesc" v-validate="'required|entry|max:128'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <!-- <v-text-field v-model="ctyForm.durationType" :label="labels.durationType" :error-messages="errors.collect('durationType')" data-vv-name="durationType" :data-vv-as="labels.durationType" v-validate="'required|max:1'"></v-text-field> -->
                  <v-autocomplete :items="durationType" v-model="durationForm.durationType" :label="labels.durationType" item-text="label" item-value="value" data-vv-name="durationType" :data-vv-as="labels.durationType" :error-messages="errors.collect('durationType')" v-validate="'required'"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      Are you sure you want to delete the selected item?
      <div class="title">{{selectedId.text}}</div>
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {

      headers: [
        { text: 'Duration Code', align: 'left', value: 'duration' },
        { text: 'Duration Value', align: 'left', value: 'durationVal' },
        { text: 'Duration Description ', align: 'left', value: 'durationDesc' },
        { text: 'Duration Type ', align: 'left', value: 'durationType' },
        TableConst.tableActionHeader
      ],
      labels: {
        valueFormTitle: 'Duration Details',
        duration: 'Duration Code*',
        durationVal: 'Duration Value*',
        durationDesc: 'Duration Code Description*',
        durationType: 'Duration Type*'
      },
      durationForm: {
        duration: null,
        durationVal: null,
        durationDesc: null,
        durationType: null
      },
      filters: {
        duration: null,
        durationVal: null,
        durationDesc: null,
        durationType: null
      },
      ctyDialog: null,
      newCty: null,
      sumbitting: undefined,
      selectedId: {
        id: null,
        text: null
      },
      promptRemove: false,
      durationType: []
    }
  },
  computed: {
    misc() {
      return this.$store.state.misc.menu
    },
    benefit() {
      return this.$store.state.parameters.benefit
    }
  },
  methods: {
    async init() {
      this.loading = true
      this.selectedId.id = null
      this.selectedId.text = null
      const apiURI = this.misc.getDurations
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((duration) => {
              const convertDuration = {
                duration: duration.duration,
                durationVal: duration.durationVal,
                durationDesc: duration.durationDesc,
                durationType: duration.durationType,
                durationTypeDesc: duration.durationTypeDesc
              }
              this.items.push(convertDuration)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    async doInit() {
      await this.$store.dispatch('miscDuration')
      this.init()
      this.getDurationType()
    },
    async doReview(data) {
      this.ctyDialog = true
      this.newCty = false
      const apiURI = this.misc.getDuration
      const expand = {
        cty: data.item.duration
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.durationForm.duration = data.duration.duration
          this.durationForm.durationVal = data.duration.durationVal
          this.durationForm.durationDesc = data.duration.durationDesc
          this.durationForm.durationType = data.duration.durationType
        }
        this.ctyDialog = true
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.newCty = true
      this.ctyDialog = true
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      this.newCty = false
      this.ctyDialog = false
      this.durationForm.duration = null
      this.durationForm.durationVal = null
      this.durationForm.durationDesc = null
      this.durationForm.durationType = null
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newCty) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.misc.createDuration
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.post(apiURI, this.durationForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.promptFieldCheck()
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.misc.updateDuration
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.put(apiURI, this.durationForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            console.log(data)
          }
        }
      }
    },
    async getDurationType() {
      const apiURI = this.misc.getDurationType
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.durationType = data.DurationTypeList
          }
        } catch (err) {
          console.log(err)
        }
      }
    },
    doPromptRemove(duration) {
      this.resetMessages()
      this.selectedId.id = duration.duration
      this.selectedId.text = duration.duration + ' - ' + duration.durationDesc
      this.promptRemove = true
    },
    doDelete() {
      const apiURI = this.misc.deleteDuration
      if (apiURI) {
        const expand = {
          duration: this.selectedId.id
        }
        this.$http.delete(expandURI(apiURI, expand)).then(result => {
          const data = result.data
          this.notify(data)
          this.init()
          console.log(data)
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
